import React from 'react';
import { Rating } from 'fronton-react';
import { css } from 'linaria';
import { memo } from 'common/hocs/memo';

type SponsoredProductReviewsProps = {
  rating: number;
  reviewsNumber: number;
  href: string;
  onClick: () => void;
};

export const SponsoredProductReviews = memo<SponsoredProductReviewsProps>(function ProductReviews({
  rating,
  reviewsNumber,
  href,
  onClick,
}) {
  const fullStarsCount = Math.floor(rating);

  return (
    <div className={ratingWrapper}>
      <Rating
        hasLink
        value={fullStarsCount}
        size={'s'}
        data-qa="product-reviews"
        onClick={onClick}
        href={href}
      >
        ({reviewsNumber})
      </Rating>
    </div>
  );
});

const ratingWrapper = css`
  height: 16px;
`;
